import { includes, take, takeLast } from "ramda";
import { useSelector } from "react-redux";

import { useCategoryActions } from "store/CategorySlice";

const useCategory = () => {
  const { loadCategory, resetCategory, loadCategoryFromContentful } = useCategoryActions();

  const { category } = useSelector((state) => state.CategorySlice);

  const CategoryCards = category && category.templateGroups;

  let categoryStarringYouCards =
    CategoryCards && CategoryCards.filter((ecard) => ecard.templateGroupType === "starring_you");

  const categoryTemplatesPerCastNumber = (castNumber) =>
    CategoryCards && CategoryCards.filter((ecard) => includes(castNumber, ecard.castNumOptions));

  const featuredStarringYouCards = CategoryCards && take(4, categoryStarringYouCards);

  categoryStarringYouCards =
    categoryStarringYouCards && categoryStarringYouCards.length > 4
      ? takeLast(categoryStarringYouCards.length - 4, categoryStarringYouCards)
      : [];

  const categoryStarringYouClipCards =
    CategoryCards && CategoryCards.filter((ecard) => ecard.templateGroupType === "starring_you_clip");

  const categoryStraightUpCards =
    CategoryCards && CategoryCards.filter((ecard) => ecard.templateGroupType === "straight_up");

  return {
    loadCategory,
    loadCategoryFromContentful,
    resetCategory,
    category,
    categoryStarringYouCards,
    categoryStraightUpCards,
    categoryStarringYouClipCards,
    categoryTemplatesPerCastNumber,
    featuredStarringYouCards,
  };
};

export default useCategory;
